import {Getters} from "vuex-smart-module";

import WarehouseShopState, {
    WarehouseShopStatus
} from "@/store/modules/warehouse-shop/warehouse-shop-state";

import WarehouseShopCategoryData from "@/http/data/warehouse-shop-category-data";
import WarehouseShopProductData from "@/http/data/warehouse-shop-product-data";
import WarehouseShopOrderData from "@/http/data/warehouse-shop-order-data";

function resolveStatusMessage(status: WarehouseShopStatus): string {
    switch (status) {
        case WarehouseShopStatus.Unauthenticated:
            return "Authentication required.";

        case WarehouseShopStatus.Forbidden:
            return "Insufficient privileges.";

        case WarehouseShopStatus.Empty:
            return "No warehouse products were found.";

        case WarehouseShopStatus.Failed:
            return "The warehouse shop could not be loaded.";

        case WarehouseShopStatus.Loading:
            return "Loading warehouse shop.";

        case WarehouseShopStatus.Ready:
            return "";

        default:
            return "Status unknown.";
    }
}

export default class WarehouseShopGetters extends Getters<WarehouseShopState> {

    get categories(): WarehouseShopCategoryData[] {
        return this.state.shop?.categories ?? [];
    }

    get products(): WarehouseShopProductData[] {
        return this.state.shop?.products ?? [];
    }

    get availableProducts(): WarehouseShopProductData[] {
        return this.getters.products.filter(product => product.available);
    }

    get currentOrder(): WarehouseShopOrderData|null {
        return this.state.shop?.current_order ?? null;
    }

    get productById(): Record<number, WarehouseShopProductData> {
        const products: Record<number, WarehouseShopProductData> = {};

        for (const product of this.getters.products) {
            products[product.id] = product;
        }

        return products;
    }

    get shopStatusMessage(): string {
        return resolveStatusMessage(this.state.shopStatus);
    }

    get productThumbnailUrls(): Record<number, string> {
        return this.state.productThumbnailUrls;
    }

    get ordersStatusMessage(): string {
        const status = this.state.ordersStatus;

        if (status === WarehouseShopStatus.Empty) return "No other open orders were found.";

        if (status === WarehouseShopStatus.Failed) return "The open warehouse orders could not be loaded.";

        return resolveStatusMessage(status);
    }
}